import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { getAssetURL } from 'src/app/constants/assets';
import { Design } from 'src/app/interfaces/design';

@Component({
  selector: 'app-design-card',
  templateUrl: './design-card.component.html',
  styleUrls: ['./design-card.component.scss']
})
export class DesignCardComponent {
  @Input() design: Design | null = null;
  @Input() isSelected: boolean = false;
  @Input() isAvailable: boolean = true;
  @Output() designClick = new EventEmitter<Design | null>();
  shouldAnimateSelection = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {  }

  ngAfterViewInit() {
    this.shouldAnimateSelection = true;
    this.changeDetectorRef.detectChanges();
  }

  getThumbnail(design: Design | null) {
    // const name = design?.displayName ?? 'Plain'
    if (design?.thumbnail) {
      return getAssetURL(design?.thumbnail);
    }
    return null;
  }
}
